export function getdata() {
	var obj = {
		tableData: [{
			bttzmc: '1',
			bttzmb: '1',
			btglzb: '要实现这样的效果，使用*******组件即可。',
			bttzdx: '1',
			bttzpl: '1',
			bttzsj: '1',
			bttztzsj: '1',


		}],
		searchdata: {
			noticeMc: '',
			noticeTemplateId: "",
			noticeZbName: "",
			noticeObj: "",
			isQiy: "",
			noticePingl: "",
			noticeTime: "",
			noticeStopTime: "",
		},
		mbsearchlist: [{
			prop: "noticeTemplateName",
			label: '模板名称',
			type: "input"
		}, {
			prop: "noticeType",
			label: '通知方式',
			type: "select",
			selectval: [{
				label: "短信",
				value: 1
			}, {
				label: "邮件",
				value: 2
			}, {
				label: "钉钉",
				value: 3
			}]

		}],
		searchlist: [{
			prop: "noticeMc",
			label: '通知名称',
			type: "input",
		}, {
			prop: "noticeTemplateId",
			label: '通知模板',
			type: "select",
			selectval: [{

			}]
		}, {
			prop: "noticeZbName",
			label: '关联指标',
			type: "input"
		}, {
			prop: "noticeObj",
			label: '通知对象',

			type: "input"
		},  {
			prop: "noticePingl",
			label: '通知频率',
			type: "select",
			selectval: [{
				label: "1天/次",
				value: "1天/次"
			}, {
				label: "1周/次",
				value: "1周/次"
			}, {
				label: "1月/次",
				value: "1月/次"
			}]
		}, {
			prop: "noticeTime",
			label: '通知时间',
			type: "realdate",
			valueformat: 'hh-mm-ss'
		}, {
			prop: "noticeStopTime",
			label: '通知停止时间',
			type: "realdate",
			valueformat: 'yyyy-MM-dd'
		}, ],
		headData: [{
			custom: true,
			title: "通知名称",
			prop: "noticeMc",
			width: 160,
			issort: true
		}, {
			custom: true,
			title: "通知模板",
			prop: "noticeTemplateName",
			width: "80"
		}, {
			title: "关联指标",
			custom: true,
			prop: "risks",
			width: "80",
		}, {
			title: "通知对象",
			custom: true,
			prop: "noticeObj",
			width: "80"
		}, {
			title: "通知频率",
			custom: true,
			prop: "noticePingl",
			width: "80"
		}, {
			title: "通知时间",
			custom: true,
			prop: "noticeTime",
			width: "80"
		}, {
			title: "通知停止时间",
			custom: true,
			prop: "noticeStopTime",
			width: "130"
		}, {
			title: "操作",
			prop: "cz",
			width: "200",
			fixed: "right",
			custom: true,
		}, ],
		headDataleft: [{
				title: "待选通知组",
				prop: "groupName",
			},
			{
				title: "操作",
				prop: "cz",
				custom: true
			},
		],
		headDataright: [{
			title: "已选通知组",
			prop: "groupName",
		}, ],
		headDatatz: [{
				title: "选择",
				prop: "choose",
				custom: true,
				width: "50px"
			},
			{
				title: "模板名称",
				prop: "noticeTemplateName",
			},
			{
				title: "操作",
				prop: "cz",
				custom: true,
				width: "100px"
			},
		],
		headDataCreate: [{
				title: "姓名",
				prop: "username",
				width: 80
			},
			{
				title: "用户名",
				prop: "nickName",
				width: 80
			},
			{
				title: "手机号",
				prop: "phoneNumber",
				width: 160,
				align: "left"
			},
			{
				title: "邮箱",
				prop: "email",
				width: 160,
				align: "left"
			}
		],
		headDatazb: [
			{
				title: "纳税人名称",
				prop: "nsrmc",
				width: "80",
			},
			{
				title: "指标大类",
				prop: "category",
				width: "80",
				custom: true
			},
			{
				title: "指标类型",
				prop: "type",
				width: "80",
				custom: true
			},
			{
				title: "指标名称",
				prop: "name",
				width: 160,
				align: "left"
			},
			{
				title: "税表名称",
				prop: "shenbType",
				width: "80"
			},
			{
				title: "预警值",
				prop: "valveValue",
				width: "80"
			},
			{
				title: "是否启用",
				prop: "enable",
				width: "80",
				custom: true
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 10,
			total: 0,
			paginationkey: 0
		},
		paginationtzz: {
			pageNum: 1,
			pageSize: 10,
			total: 0,
			paginationkey: 0
		}

	}
	return obj
}
